var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackgroundMobile = function SvgBackgroundMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 390 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M390 33V0S272.425 30.688 194 30.688 0 0 0 0v33h390Z"
  })));
};
export default SvgBackgroundMobile;